import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PromotionComponent } from './promotion/promotion.component';
import { TournamentBannerModule } from '@fantaz/tournaments-v2/ui/tournament-banner';

@NgModule({
  imports: [CommonModule, TournamentBannerModule],
  declarations: [PromotionComponent],
  exports: [PromotionComponent],
})
export class TournamentsUiPromotionModule {}
